module.exports = __webpack_public_path__ + "img/img5.93cd21f6.png";